import { Row, Col } from "react-bootstrap";
import Welcome from "../../mycomp/Dashboard/eCommerce/Welcome";
import RevenueGrowth from "../../mycomp/Dashboard/CRM/SRevenueGrowth";
import LeadConversion from "../../mycomp/Dashboard/CRM/SLeadConversion";
import TotalOrders from "../../mycomp/Dashboard/CRM/STotalOrders";
import AnnualProfit from "../../mycomp/Dashboard/CRM/SAnnualProfit";
import RentalIncome from "../../mycomp/Dashboard/RealEstate/RentalIncome";
import SalesReport from "../../mycomp/Dashboard/CRM/SalesReport";
const SuperAdminHome = () => {
  return (
    <>
      <Row>
        <Col xs={12} lg={6}>
          <Welcome />
        </Col>
      </Row>

       <Row>
        <Col xs={12} sm={6} lg={6} xl={6} xxl={3}>
          <RevenueGrowth />
        </Col>

        <Col xs={12} sm={6} lg={6} xl={6} xxl={3}>
          <LeadConversion />
        </Col>

        <Col xs={12} sm={6} lg={6} xl={6} xxl={3}>
          <TotalOrders />
        </Col>

        <Col xs={12} sm={6} lg={6} xl={6} xxl={3}>
          <AnnualProfit />
        </Col>
      </Row>

      <Row>

        <Col xs={12} sm={12} lg={6} xl={6} xxl={6}>
          <RentalIncome />
        </Col>

        <Col xs={12} sm={12} lg={6} xl={6} xxl={6}>
          <SalesReport />
        </Col>

      </Row>
    </>
  );
};

export default SuperAdminHome;